import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AmplifyHttpClient } from '../auth/http.amplify-httpclient';
import { loaderTypes } from '@app/shared/component/loader/loader';
import { HttpErrorResponse } from '@angular/common/http';
import { DocumentService } from '../vault/document.service';

@Injectable({
  providedIn: 'root',
})
export class ChecklistTaskService {
  private API_TASK_URL = 'api/checklist';
  constructor(private readonly httpService: AmplifyHttpClient, private documentService: DocumentService) {}

  getChecklistTaskId(request): Observable<any> {
    return this.httpService.post<any>(`${this.API_TASK_URL}/new-checklist-task-id`, request).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  createChecklistTask(request): Observable<any> {
    return this.httpService.post<any>(`${this.API_TASK_URL}/checklist-task`, request).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  updateChecklistTask(request): Observable<any> {
    return this.httpService.patch<any>(`${this.API_TASK_URL}/checklist-task`, request).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  deleteChecklistTask(taskId): Observable<any> {
    return this.httpService.delete<any>(`${this.API_TASK_URL}/checklist-task/${taskId}`).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  createUploadUrl(request): Observable<any> {
    return this.httpService.post<any>(`${this.API_TASK_URL}/create-attachment-upload-url`, request).pipe(
      map((response: any) => {
        if (response.status == 200 || response.status == 201) {
          if (response?.data?.limit_exceeded) {
            let error: HttpErrorResponse = new HttpErrorResponse({ error: response?.data, status: 400 });
            throw error;
          } else {
            return response.data;
          }
        } else {
          return response;
        }
      })
    );
  }

  updateUploadStatus(request): Observable<any> {
    return this.httpService.patch<any>(`${this.API_TASK_URL}/attachment-upload`, request, loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        } else {
          return response;
        }
      })
    );
  }

  deleteUploadedAttachment(userId, id): Observable<any> {
    return this.httpService.delete<any>(`${this.API_TASK_URL}/attachment-upload/${userId}/${id}`).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        } else {
          return response;
        }
      })
    );
  }

  downloadAttachment(userId, fileId): Observable<any> {
    return this.httpService.get<any>(`${this.API_TASK_URL}/attachment-download-url/${userId}/${fileId}`).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        } else {
          return response;
        }
      })
    );
  }

  getAllForms(userId: number) {
    let url: string = `api/vault/forms-user/${userId}`;
    let w_id = this.documentService.getWorSpaceId();
    if (w_id != null) {
      url = url + `?w_id=${w_id}`;
    }

    return this.httpService.get(url, null, loaderTypes.mainAnimation).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getChecklistDetails(checklistId: number) {
    return this.httpService.get<any>(`${this.API_TASK_URL}/checklist-task/${checklistId}`).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        } else {
          return response;
        }
      })
    );
  }

  getAttachmentsListForTask(userId: number, checklistTaskId: number) {
    return this.httpService.get<any>(`${this.API_TASK_URL}/attachment-list/${userId}/${checklistTaskId}`).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        } else {
          return response;
        }
      })
    );
  }

  getTaskActivityLog(checklistId) {
    return this.httpService.get<any>(`${this.API_TASK_URL}/checklist-task-activity/${checklistId}`).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  getChecklistTasksLinkedWithForms(userId, checklistId) {
    return this.httpService.get<any>(`${this.API_TASK_URL}/checklist-task-linked-form/${userId}/${checklistId}`, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getExternalLinkName(request): Observable<any> {
    return this.httpService.post<any>(`${this.API_TASK_URL}/external-link-name`, request).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
}
